import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  from,
  HttpLink,
  InMemoryCache,
  split,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { getMainDefinition } from "apollo-utilities";
import React from "react";
import { useAuth } from "react-oidc-context";
import { WebSocketLink } from '@apollo/client/link/ws';

const AuthorizedApolloProvider = ({ children }: any) => {

  // Example of creating links with error handling:
  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) =>
        console.log(`GraphQL error: Message: ${message}, Location: ${locations}, Path: ${path}`)
      );
    }
    if (networkError) {
      console.log(`Network error: ${networkError}`);
    }
  });

  const httpLink = new HttpLink({
    uri: import.meta.env.VITE_GRAPHQL,
  });

  const { user } = useAuth();

  function getHeaders() {
    const headers: any = {}
    const token = user?.access_token;
    if (token) {
      headers["Authorization"] = `Bearer ${token}`
    }
    return headers
  }
  // // Create a WebSocket link:
  const wsLink = new WebSocketLink({
    uri: import.meta.env.VITE_GRAPHQL_WS, // use wss for a secure endpoint
    options: {
      reconnect: true,
      lazy: true,
      timeout: 30000,
      inactivityTimeout: 30000,
      connectionParams: {
        headers: getHeaders(),
      },
    },
  });

  const RefreshTokenLink = setContext(async (operation, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${user?.access_token}`,
      },
    };
  });

  const cache = new InMemoryCache({
    typePolicies: {
      User: {
        merge: true,
      },
    },
  });

  // Using the ability to split links, you can send data to each link depending on the kind of operation being sent
  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    wsLink,
    ApolloLink.from([errorLink, httpLink]),
  );

  const apolloClient = new ApolloClient({
    link: from([RefreshTokenLink as any, splitLink] as any) as any,
    cache: new InMemoryCache(),
    connectToDevTools: true,
  });

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};

export default AuthorizedApolloProvider;
